import React, { useEffect, useState } from "react";
import Loader from "components/Layout/Loader";
import Profile from "components/Layout/Profile";
import { icons, certificatePath } from "utils/constants";
import { generatePreSignedUrl } from "utils/helpers";

const CertificatePreview = ({ access, elem, loadingIndexes, index }) => {
  const { s3File, img } = elem;
  const urlType = img?.split(".").pop();
  const [s3URLPdf, setS3URLPdf] = useState(null);

  useEffect(() => {
    const fetchS3Url = async () => {
      if (urlType === "pdf") {
        const url = await generatePreSignedUrl(img, certificatePath);
        setS3URLPdf(url);
      }
    };

    fetchS3Url();
  }, [img, urlType]);

  return (
    // <div className="col-md-3">
    <>
      {loadingIndexes?.includes(index) ? (
        <div className="d-flex justify-content-center align-items-center h-100">
          <Loader />
        </div>
      ) : access?.isUpgradeButton ? (
        <img
          src={icons.membershipCertificate}
          alt="cer"
          className="fit-image fill"
        />
      ) : urlType === "pdf" && s3URLPdf ? (
        <iframe
          src={s3URLPdf}
          title="certificate"
          style={{
            height: "100%",
            width: "100%",
          }}
        />
      ) : (
        <Profile url={s3File} size="s-136" />
      )}
      </>
    // </div>
  );
};

export default CertificatePreview;


// import Loader from "components/Layout/Loader";
// import Profile from "components/Layout/Profile";
// import React from "react";
// import { icons } from "utils/constants";

// const CertificatePreview = ({ access, elem, loadingIndexes, index }) => {
//   const { s3File, img, previewUrl } = elem;
//   const urlType = img?.split(".").pop();
//   return (
//     <div className="col-md-3">
//       {loadingIndexes?.includes(index) ? (
//         <div className="d-flex justify-content-center align-items-center h-100">
//           <Loader />
//         </div>
//       ) : access?.isUpgradeButton ? (
//         <img
//           src={icons.membershipCertificate}
//           alt="cer"
//           className="fit-image fill"
//         />
//       ) : ["pdf"].includes(urlType) ? (
//         <iframe
//           src={previewUrl}
//           title="certificate"
//           style={{
//             height: "100%",
//             width: "100%",
//           }}
//         />
//       ) : (
//         <Profile url={s3File} size="s-136" />
//         /* <img src={s3File} alt="cer" className="fit-image fill" /> */
//       )}
//     </div>
//   );
// };

// export default CertificatePreview;
